import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("El nombre es obligatorio"),
});

const ConceptCreate = ({ refetchConcept }) => {
  const { postData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { mutate: createConcept, isLoading: isPostLoading } = postData(
    "/concepts",
    {},
    {},
    {
      onSuccess: (data) => {
        refetchConcept();
        reset();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const onSubmit = (data) => {
    createConcept({
      ...data,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div
          className={`col mb-3 ${
            errors.name?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Nombre del concepto</label>
          <input type="text" className="form-control" {...register("name")} />
          {errors.name?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.name?.message}
            </div>
          ) : null}
        </div>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="submit"
        disabled={isPostLoading}
      >
        Guardar
      </button>
    </form>
  );
};

export default ConceptCreate;
